import { Tag } from 'antd';
import styled from 'styled-components';

import { CUSTOM_REPORT_RISKS } from '@/utils/enum';

interface TagRiskProps {
	$riskLevel?: number;
}

export const TagRisk = styled(Tag)<TagRiskProps>`
	border-radius: 5px;
	width: 68%;
	max-width: 8rem;
	text-align: center;
	padding: 0.25rem 0.5rem;
	span {
		color: ${({ theme, $riskLevel }) =>
			$riskLevel === CUSTOM_REPORT_RISKS.MODERATE
				? theme.palette.secondary['400']
				: theme.palette.secondary.white};
		font-size: ${({ theme }) => theme.fonts.body.sm.fontSize};
		font-weight: 400;
	}
`;
